<template>
  <!-- Display the label and the text from props -->
  <v-input :hide-details="size=='sm'">
    <div class="outer" :style="style" >
      <label v-if="label">{{label}}</label>
      <div class="value-holder">
        <copyable>
          <div class="value" :class="{'large-text' : largeText}">
            <!-- @slot Use this slot for the default text -->
            <slot></slot>
            <span class="suffix">
              <!-- @slot Text appends to the slot name "suffix" -->
              <slot name="suffix"></slot>
            </span>
          </div>
        </copyable>
      </div>
    </div>
  </v-input>

</template>

<script>
  /**
   * @displayName FieldDisplay
   */
import copyable from "@/_components/shared/copyable"
import ellipsisText from "@/_components/shared/ellipsis-text"
export default {
  components : {copyable,ellipsisText},
  props : {
    /**
     * Set name for the label
     */
    label : {type:String,default:""},
    /**
     * Set size for the text. Small (sm) or Medium (md)
     */
    size : {type:String,default:""},
    /**
     * If the size was not mentioned we can set large-text as attribute for an element
     */
    'large-text' : {type:Boolean,default:false}
  },
  computed : {
    zoom()
    {
      /**
       * Assign corresponding sizes to the font
       */
      switch(this.size)
      {
        case "sm":return 0.7;
        case "md":return 1;
        default: return 1.3;
      }
    },
    style()
    {
      /**
       * Sets default value to the normal font
       */
      return {zoom : this.zoom};
    },
  },
  data()
  {
    return {}
  },
  methods : {
  }
}
</script>

<style scoped lang="scss">
.outer
{
  zoom : .8;
  width:100%;
  padding-bottom:10px;
  padding-top:20px;
  align-items:stretch;
  display:flex;
  flex-direction:column;
  // top:-5px;
  // position:relative;
  border-bottom:1px rgba(128,128,128,.5) dashed;

  label
  {
    line-height:1em;
    height:1em;
    display:flex;
    opacity:.6;
    align-items: flex-end;
    zoom:.75;
    top:-15px;
    position:relative;
    flex-grow:1;
  }
  .value-holder
  {
    flex-grow:1;
    display:flex;
    width:100%;
    justify-content: space-between;
    flex-wrap:nowrap;
    height:24px;

    .value{
      display:flex;
      height:24px;
      line-height:1.05em;
      font-size:.90em;
      align-items: center;
      flex-wrap: nowrap;
      width:100% !important;
    }
    .value.large-text
    {
      font-size:1.8em;
    }
  }
  .suffix
  {
    margin:0px 0px 0px 5px;
    opacity:.6;
  }
}
</style>
